module.exports = __webpack_public_path__ + "img/pnb.b14fcaa4.jpg";